import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c5m05un - Link to quotation form with prefilled steps
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('show-quick-links-product', () => {
            activateAbTestByEvent('show-quick-links-product');
            this.$store.ab.quickLinksProduct = true;
        });
        window.addEventListener('show-quick-links-product-v3', () => {
            activateAbTestByEvent('show-quick-links-product-v3');
            this.$store.ab.quickLinksProductV3 = true;
        });
    },
});
